import React from 'react'
import * as Flags from '../flags'
import type { CountryType } from '../PhoneField.helpers'
import { CountryDropdownLabel } from '../PhoneField.styles'

export const PhoneFieldDropdownLabel = ({
  country,
  setSelectedCountry
}: {
  country: CountryType
  setSelectedCountry: (country: CountryType) => void
}) => {
  const CountryFlag = Flags[country.iso]
  return (
    <div
      key={country.prefix}
      className={CountryDropdownLabel}
      onClick={() => setSelectedCountry(country)}
    >
      <CountryFlag />
      {` (+${country.prefix}) `}
      {country.label}
    </div>
  )
}
